import React, { useState } from "react";
import {
  Button,
  Form,
  Grid,
  Header,
  Image,
  Message,
  Segment,
} from "semantic-ui-react";
import axios from "axios";
import logo from "../../../assets/images/logo_sef.png";
import {
  Link,
  useHistory,
  // useRouteMatch,
  useLocation,
} from "react-router-dom";
import jwt from "jsonwebtoken";
import { message } from "antd";
import queryString from "query-string";
import employeeRedirect from "../../../helpers/employeeRedirect";
import { docTitle } from "../../../helpers/docTitle";

function LoginForm(props) {
  docTitle("Login - SEF");
  const history = useHistory();
  // const { url, path } = useRouteMatch();

  const [user, setUser] = useState({
    email: "",
    password: "",
  });
  const [errors, setErrors] = useState({
    email: false,
    password: false,
    response: { show: false, type: "success", message: "" },
  });
  const [loading, setLoading] = useState(false);
  const { state = {} } = useLocation();
  const { prevLocation, search } = state;
  // const { schoolName, role, senderFn, senderLn } = queryString.parse(search);
  // const prev = `${prevLocation}${search}`;
  // console.log(state.search, "<----", `${prevLocation}${search}`);

  const handleSignin = async () => {
    try {
      // const { confirmPass, ...user } = user;

      if (
        !user.email ||
        !new RegExp(/^[a-z0-9._-]+@[a-z0-9.-]+\.[a-z]{2,4}$/).test(user.email)
      )
        return setErrors({ ...errors, email: true });
      if (!user.password) return setErrors({ ...errors, password: true });
      setLoading(true);
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/users/signin`,
        {
          ...user,
        }
      );
      setLoading(false);
      if (response.status === 200) {
        localStorage.setItem("token", response.data.data);
        localStorage.setItem(
          "query",
          JSON.stringify(queryString.parse(search))
        );
        const token = localStorage.getItem("token");
        const user = jwt.verify(token, "success");
        if (user.role !== "admin" && user.role !== "user") {
          await employeeRedirect(axios, history, prevLocation, message);
          return;
        }

        return history.push(prevLocation || `/user/${user.uuid}`);
      }
      return;
    } catch (error) {
      console.log(error.message, process.env.REACT_APP_API_URL);
      setLoading(false);
      if (error.message === "Network Error") {
        return message.error(error.message);
      }
      if (error?.response?.status === 400) {
        return message.error(error.response.data.error);
      }
      if (error?.response?.status === 401) {
        message.error(error.response.data.error);
      }
      if (error?.response?.status === 404) {
        return message.error(error.response.data.error);
      }
      if (error?.response?.status === 500) {
        return message.error(error.response.data.error);
      }
    }
  };

  return (
    <Grid textAlign="center" style={{ height: "100vh" }} verticalAlign="middle">
      <Grid.Column style={{ maxWidth: 450 }}>
        <Image src={logo} centered />
        <Header as="h2" textAlign="center" color="dodge blue">
          Log into your account
        </Header>
        {errors.response.show ? (
          <Message
            error={errors.response.type === "error"}
            success={errors.response.type === "success"}
          >
            {errors.response.message}
          </Message>
        ) : null}
        <Form size="large">
          <Segment raised>
            <Form.Input
              fluid
              icon="mail"
              iconPosition="left"
              placeholder="E-mail address"
              error={
                errors.email
                  ? {
                      content: "Please enter a valid email address",
                      pointing: "below",
                    }
                  : false
              }
              onChange={(e) => {
                setUser({ ...user, email: e.target.value });
                setErrors({ ...errors, email: false });
              }}
            />
            <Form.Input
              fluid
              icon="lock"
              iconPosition="left"
              placeholder="Password"
              type="password"
              error={errors.password}
              onChange={(e) => {
                setUser({ ...user, password: e.target.value });
                setErrors({ ...errors, password: false });
              }}
            />
            <p
              style={{ display: "flex", fontSize: 13, fontWeight: 400 }}
              // onClick={() => setOpen(!open)}
            >
              <Link to={{ pathname: "/auth/reset-password/request", state }}>
                Forgot Password
              </Link>
            </p>
            <Button
              // style={{ backgroundColor: "dodgerblue", color: "white" }}
              color="dodge blue"
              fluid
              circular
              size="large"
              loading={loading}
              onClick={handleSignin}
            >
              Log In
            </Button>
          </Segment>
        </Form>
        <Message floating>
          Don't have an account? <Link to={"/auth/signup"}>Sign Up</Link>
        </Message>
      </Grid.Column>
      {/* <ResetRequest open={open} setOpen={setOpen} /> */}
    </Grid>
  );
}

export default LoginForm;
